import { render, staticRenderFns } from "./postItemCarousel.vue?vue&type=template&id=f025f5d6&scoped=true&"
import script from "./postItemCarousel.vue?vue&type=script&lang=js&"
export * from "./postItemCarousel.vue?vue&type=script&lang=js&"
import style0 from "./postItemCarousel.vue?vue&type=style&index=0&id=f025f5d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f025f5d6",
  null
  
)

export default component.exports